// import { EncryptedStorage } from 'encrypt-storage';
//import { trackException } from '../../services/azure/applicationInsights/ApplicationInsightsActions';

export const setStorageItem = (key, value) => {
    return new Promise((resolve, reject) => {
        localStorage.setItem(key, JSON.stringify(value));
        // .then((response) => {
        //     resolve(true);
        // })
        // .catch((error) => {
        //     // trackException('EncryptedLocalStorageActions.js - setStorageItem()', error);
        //     reject(error);
        // });
    });
};

export const getStringStorageItem = (key) => {
    return new Promise((resolve, reject) => {
        resolve(localStorage.getItem(key));
        // localStorage.getItem(key);
        //     .then((stringValue) => {
        //         resolve(stringValue);
        //     })
        //     .catch((error) => {
        //         // trackException('EncryptedLocalStorageActions.js - getStringStorageItem()', error);
        //         reject(error);
        //     });
    });
};

export const getObjectStorageItem = (key) => {
    return new Promise((resolve, reject) => {
        const jsonValue = localStorage.getItem(key);
        resolve(jsonValue != null ? JSON.parse(jsonValue) : null);
        // localStorage.getItem(key)
        //     .then((jsonValue) => {
        //         resolve(jsonValue != null ? JSON.parse(jsonValue) : null);
        //     })
        //     .catch((error) => {
        //         // trackException('EncryptedLocalStorageActions.js - getObjectStorageItem()', error);
        //         reject(error);
        //     });
    });
};

export const clearStorage = () => {
    localStorage.clear();
};